import { faPlus, faTrash } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button, Col, Form, Row, Table } from "react-bootstrap";
import { formatMoeda, getPseudoID, handleNumberOnly, validarCNPJ, validarCPFCNPJ } from "../../../utils/utils";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../../app/store";
import { DispInterface } from "../../../interfaces";
import {
    addDispositivoValePedagio,
    removeDispositivoValePedagio,
    changeValePedCategoria
} from "../../../features/manifestoSlice";
import { useState } from "react";
import { JConfirmDelete, MensagemModal } from "../../../components/Components";
import { TypeCategCombVeic } from "../../../lists";

const initialForm = {
    id: 0,
    CNPJForn: '',
    CPFCNPJPg: '',
    nCompra: '',
    vValePed: 0,
    tpValePed: '',
}

export default function ValePedagio() {
    const dispatch = useDispatch();
    const valePedatgio = useSelector((state: RootState) => state.manifesto.manifesto.modal_rodoviario.infANTT.valePed);
    const [showAlert, setShowAlert] = useState<boolean>(false);
    const [messageAlert, setMessageAlert] = useState<string>('');
    const [form, setForm] = useState(initialForm);
    const [selected, setSelected] = useState<number>(0);
    const [showModal, setShowModal] = useState<boolean>(false);

    const alerta = (message: string) => {
        setMessageAlert(message);
        setShowAlert(true)
    }

    const validaPreenchimento = () => {

        if (form.CNPJForn === "") {
            alerta('Informe o CNPJ Fornecedor');
            return false;
        }

        if (!validarCNPJ(form.CNPJForn)) {
            alerta('CNPJ Fornecedor inválido.');
            return false;
        }

        if (form.CPFCNPJPg === "") {
            alerta('Informe o CPF/CNPJ do responsável');
            return false;
        }

        if (!validarCPFCNPJ(form.CPFCNPJPg)) {
            alerta('CPF/CNPJ do responsável inválido.');
            return false;
        }

        if (form.vValePed === 0 || form.vValePed.toString().trim() === "") {
            alerta('Informe o Vlr. do Vale Pedágio');
            return false;
        }

        if (valePedatgio.disp.find((item: DispInterface) =>
            item.CNPJForn === form.CNPJForn && item.CPFCNPJPg === form.CPFCNPJPg && item.nCompra === form.nCompra)) {
            alerta('Nro comprovante já adicionado');
            return false;
        }

        return true;
    }

    const handleCloseModal = () => {
        setShowModal(false);
        setSelected(0);
    }

    const handleOpenModal = (id: number) => {
        setSelected(id);
        setShowModal(true);
    }

    const handleAdd = () => {
        if (validaPreenchimento()) {
            dispatch(addDispositivoValePedagio({
                ...form,
                id: getPseudoID()
            }));
            setForm(initialForm);
        }
    }

    const handleRemove = (id: number) => {
        dispatch(removeDispositivoValePedagio(id));
        setForm(initialForm);
        setShowModal(false);
        setSelected(0);
    }

    const handleChangeCategoria = (e: any) => {
        dispatch(changeValePedCategoria(e.target.value));
    }

    const handleChange = (e: any) => {
        const { name, value } = e.target;
        setForm((prev) => ({
            ...prev,
            [name]: value
        }))
    }

    return (<>
        <Row className="mb-3">
            <Col md={4}>
                <Form.Group>
                    <Form.Label>Categoria de Combinação Veicular</Form.Label>
                    <Form.Select name="categCombVeic" value={valePedatgio.categCombVeic}
                        onChange={handleChangeCategoria}>
                        {TypeCategCombVeic.map(x => (
                            <option key={x.id} value={x.id}>{x.name}</option>
                        ))}
                    </Form.Select>
                </Form.Group>
            </Col>
        </Row>
        <hr />
        <Row className="mb-3 g-2">
            <Col md={2}>
                <Form.Group>
                    <Form.Label>CNPJ Fornecedor</Form.Label>
                    <Form.Control name="CNPJForn" value={form.CNPJForn} maxLength={14}
                        onChange={handleChange} onKeyUp={handleNumberOnly} />
                </Form.Group>
            </Col>
            <Col md={2}>
                <Form.Group>
                    <Form.Label>CPF/CNPJ Responsável</Form.Label>
                    <Form.Control name="CPFCNPJPg" value={form.CPFCNPJPg} maxLength={14}
                        onChange={handleChange} onKeyUp={handleNumberOnly} />
                </Form.Group>
            </Col>
            <Col md={2}>
                <Form.Group>
                    <Form.Label>Nro. Comprovante</Form.Label>
                    <Form.Control name="nCompra" value={form.nCompra} onChange={handleChange} maxLength={20} />
                </Form.Group>
            </Col>
            <Col md={2}>
                <Form.Group>
                    <Form.Label>Vlr. do Vale Pedágio</Form.Label>
                    <Form.Control name="vValePed" value={form.vValePed}
                        onChange={(e) => {
                            const { name, value } = e.target;
                            setForm({
                                ...form,
                                vValePed: parseFloat(value.replace(/[^0-9.]/g, "").replace(/(\.\d{2})\d+/, "$1"))
                            })
                        }}
                        type="number" maxLength={16} min={0} />
                </Form.Group>
            </Col>
            <Col md>
                <Form.Group>
                    <Form.Label>Tipo do Vale Pedagio </Form.Label>
                    <Form.Select name="tpValePed" onChange={handleChange} value={form.tpValePed}>
                        <option value="">Nao informado</option>
                        <option value="01">01 - TAG</option>
                        <option value="02">02 - Cupom</option>
                        <option value="03">03 - Cartão</option>
                    </Form.Select>
                </Form.Group>
            </Col>
            <Col md={'auto'} className="d-flex align-items-end">
                <Form.Group>
                    <Button type="button" title="Adicionar disponitivo na lista" onClick={handleAdd}>
                        <FontAwesomeIcon icon={faPlus} /> Adicionar
                    </Button>
                </Form.Group>
            </Col>


        </Row>

        <Table striped bordered hover size="sm">
            <thead className="table-light">
                <tr>
                    <th className="text-center" style={{ width: '2.5rem' }}>#</th>
                    <th>CNPJ do fornecedor</th>
                    <th>CPF/CNPJ Responsável</th>
                    <th>Nro Comprov. Compra</th>
                    <th>Vlr. do Vale Pedágio</th>
                    <th>Tipo Vale Pedágio</th>
                </tr>
            </thead>

            <tbody>
                {valePedatgio?.disp?.map((item: DispInterface) => (
                    <tr key={item.id}>
                        <td className="text-center">
                            <a href="javasctipt:void(0)" className="text-danger" onClick={() => handleOpenModal(item.id)}>
                                <FontAwesomeIcon icon={faTrash} />
                            </a>
                        </td>
                        <td>{item.CNPJForn}</td>
                        <td>{item.CPFCNPJPg}</td>
                        <td>{item.nCompra}</td>
                        <td>{formatMoeda(item.vValePed, 2)}</td>
                        <td>{item.tpValePed}</td>
                    </tr>
                ))}
            </tbody>
        </Table>
        <MensagemModal
            show={showAlert}
            handleClose={() => setShowAlert(false)}
            mensagem={messageAlert}
        />

        <JConfirmDelete
            showModal={showModal}
            handleCloseModal={handleCloseModal}
            handleDelete={handleRemove}
            selectedObject={''}
            id={selected}
        />
    </>)
}